<rs-tab-group role="tablist">
  <rs-tab-group-title>
    <h3>User Authorizations</h3>
  </rs-tab-group-title>
  <rs-tab role="tab" [label]="(editAuthorizationsValue ? 'Manag' : 'View')+'ing User Authorizations'" style="padding: 0 30px;" >
    <div id="scrollId"></div>
    <div class="view-auth-container">
      <a routerLink="/userAdmin/manage" class="back-to-users-link"><< Back to Users List</a>
      <div class="userId">
        @if (selectedUserInfoDataValue) {
          <div>
            <span>Selected User:</span> <span>{{selectedUserInfoDataValue.userId}}</span>
            <span style="padding-left: 15px;">User Type:</span> <span>{{selectedUserInfoDataValue.userType | titlecase }}</span>
          </div>
        }
        <div class="btns-div">
          @if(userRoleInfoDataValue.userType === 'admin') {
            @if (!editAuthorizationsValue && selectedUserInfoDataValue.userType === 'user') {
              <button rs-raised-button color="primary" (click)="convertUserDelegate('delegate')">Convert To Delegate</button>
            }
            @if (!editAuthorizationsValue && selectedUserInfoDataValue.userType === 'delegate') {
              <button rs-raised-button color="primary" (click)="convertUserDelegate('user')">Convert To User</button>
            }
          }
          @if (!editAuthorizationsValue && selectedUserInfoDataValue.userType !== 'delegate') {
            <button rs-raised-button color="primary" (click)="editAuthorizations.set(true)">Edit</button>
          }
          @if (editAuthorizationsValue) {
            <button rs-raised-button color="secondary" (click)="editAuthorizations.set(false); disableSave.set(true)">Cancel</button>
          }
          @if (editAuthorizationsValue) {
            <button rs-raised-button color="primary" (click)="saveAuths()" [disabled]="disableSaveValue && !(changeToValue === 'user')">Save</button>
          }
        </div>
      </div>
      <div>
        <rs-notification role="alert" type="error" [visible]="fetchingUserAuthsErrorsValue.length > 0" closeable (visibleChange)="fetchingUserAuthsErrors.set('')">{{fetchingUserAuthsErrorsValue}}</rs-notification>
        <rs-notification role="alert" type="error" [visible]="updateUserAuthsErrorsValue.length > 0" closeable (visibleChange)="updateUserAuthsErrors.set('')">{{updateUserAuthsErrorsValue}}</rs-notification>
        @if (!editAuthorizationsValue) {
          <pt-app-view-user-auths [userAndAdminAuths]="userAndAdminAuths"></pt-app-view-user-auths>
        }
        @if (editAuthorizationsValue && userAndAdminAuths.length > 0) {
          <pt-app-manage-user-auths [userAndAdminAuths]="userAndAdminAuths" (changesFromEdit)="detectEditChanges($event)"></pt-app-manage-user-auths>
        }
      </div>
      <div class="pagination-holder">
        <div style="color: red;">{{!disableSaveValue ? 'Please SAVE your changes before navigating away from this page.' : ''}}</div>
        @if (userAndAdminAuths.length > 0) {
          <rs-paginator role="navigation" [pageIndex]="pageIndex" [class]="!disableSaveValue ? 'no-events' : ''" [length]="totalAuths" [pageSize]="pageSize"
            [pageSizeOptions]="[10,100]" (page)="getUserAuths($event)" showFirstLastButtons>
          </rs-paginator>
        }
      </div>
    </div>
    <rs-dialog role="dialog" id="confirmation-dialog" [visible]="showConfirmationValue" (visibleChange)="showConfirmation.set(false)" aria-label="Confirmation" heading="Confirmation">
      @if (changeToValue === 'delegate') {
        <p style="padding: 20px;">Are you sure about converting this user role to delegate ?</p>
      }
      @if (changeToValue === 'user')  {
        <p style="padding: 20px;">Converting delegate to user only happens in the next screen, once you save the authorizations.</p>
      }
      <div class="confirmation-btns-div">
        <button rs-raised-button color="secondary" (click)="showConfirmation.set(false)">Cancel</button>
        <button rs-raised-button color="primary" (click)="proceedToNext()">{{changeToValue === 'user' ? 'Proceed' : 'Yes'}}</button>
      </div>
    </rs-dialog>
  </rs-tab>
</rs-tab-group>
